export default __webpack_public_path__ + "static/media/maduro-4Closed.91560656.jpg";